import { mdiCheckboxBlankCircle } from '@mdi/js';
import React from 'react';
import * as S from './legend.styles';

export interface ILegendProps {
    labels: string[];
    direction?: 'horizontal' | 'vertical';
}
export class Legend extends React.Component<ILegendProps> {
    public render(): React.ReactElement {
        const items = this.props.labels.map(
            (label: string, i: number): React.ReactElement => {
                return (
                    <S.LegendItem key={label}>
                        <S.LegendIcon ord={i} path={mdiCheckboxBlankCircle} />
                        {label}
                    </S.LegendItem>
                );
            },
        );
        return (
            <S.Legend direction={this.props.direction}>
                <S.LegendItems>{items}</S.LegendItems>
            </S.Legend>
        );
    }
}
